import apiService from '../../../services/apiService';
import axios from 'axios';

const CAMP_API = '/ykrestapi/CampChannel';
const API_BASE_URL = process.env.REACT_APP_YK_API_BASE || 'http://localhost:5000/ykrestapi';

const volunteerService = {
  getCenters: async (countryDesc = 'USA') => {
    const response = await apiService.post(`${CAMP_API}/GetCenterForCamp`, {
      Country_Desc: countryDesc,
    });
    return response.data;
  },

  insertVolunteer: async (payload, signal) => {
    const response = await apiService.post(`${CAMP_API}/InsertVolunteer`, payload, { signal });
    return response.data;
  },

  sendConfirmationEmail: async (payload, signal) => {
    const response = await axios.post(
      `${API_BASE_URL}/MessageChannel/SendEmailMessage?appName=Waiver&templateName=VolunteerWaiver&orgId=3`,
      payload,
      { timeout: 30000, signal }
    );
    return response.data;
  },

  checkWaiverStatus: async (firstName, lastName, email) => {
    const url = `${API_BASE_URL}/api/volunteer/waiver-status`;
    console.error('[WaiverCheck] POST URL:', url, '| ts:', Date.now());

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        email: email.trim(),
      }),
    });

    console.error('[WaiverCheck] Response:', res.status, res.statusText, '| url:', res.url);

    if (!res.ok) {
      const body = await res.text().catch(() => '');
      console.error('[WaiverCheck] Error body:', body);
      const err = new Error(`HTTP ${res.status}`);
      err.response = { status: res.status, data: body };
      throw err;
    }

    const data = await res.json();
    console.error('[WaiverCheck] Success:', JSON.stringify(data));
    return data;
  },
};

export default volunteerService;
